declare global {
  interface Window {
    __TALUMI_CONFIG__?: { apiUrl?: string };
  }
}

const DEFAULT_API_URL = 'http://localhost:3000/graphql';

/**
 * Where the GraphQL API lives.
 *
 * Runtime first (`public/config.js`, rewritten by the container's entrypoint),
 * then the build-time `VITE_API_URL`, then localhost. That order is what makes
 * the image environment-agnostic: the same bundle is deployed to staging and to
 * production, and only the file nginx writes differs.
 */
export function resolveGraphqlEndpoint(): string {
  const runtime = window.__TALUMI_CONFIG__?.apiUrl?.trim();

  return runtime || import.meta.env.VITE_API_URL || DEFAULT_API_URL;
}

export const graphqlEndpoint = resolveGraphqlEndpoint();

/**
 * OpenRouter's own catalogue, where an operator reads what a model id means
 * and what it costs. Linked from both screens that name a model.
 */
export const OPENROUTER_MODELS_URL = 'https://openrouter.ai/models';
